import React from "react";

export default () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m3.62074,22.99778q-1.30926,0 -2.22574,-0.91648t-0.91648,-2.22574q0,-1.30926 0.91648,-2.22574t2.22574,-0.91648q1.30926,0 2.22574,0.91648t0.91648,2.22574q0,1.30926 -0.91648,2.22574t-2.22574,0.91648zm0,-2.09482q0.44515,0 0.74628,-0.30113t0.30113,-0.74628q0,-0.44515 -0.30113,-0.74628t-0.74628,-0.30113q-0.44515,0 -0.74628,0.30113t-0.30113,0.74628q0,0.44515 0.30113,0.74628t0.74628,0.30113zm4.18963,2.09482q0.36659,-0.47133 0.58917,-0.98194t0.3535,-1.11287l2.19956,0l0,-7.33185q0,-0.86411 -0.61535,-1.47946t-1.47946,-0.61535l-5.23704,0l0,3.14222q-0.54989,0 -1.08669,0.10474t-1.00813,0.31422l0,-5.656l3.14222,0l0,-3.56119q0,-2.01626 1.40091,-3.41717t3.41717,-1.40091q1.46637,0 2.67089,0.79865t1.78059,2.13409l7.14856,16.96801l2.43522,0l0,2.09482l-7.33185,0l0,-2.09482l2.61852,0l-6.78197,-16.13008q-0.31422,-0.75937 -1.00813,-1.21761t-1.53183,-0.45824q-1.15215,0 -1.9377,0.78556t-0.78556,1.9377l0,3.56119l2.09482,0q1.72822,0 2.95893,1.2307t1.2307,2.95893l0,9.42667l-5.23704,0zm-0.5237,-6.80815z"
      fill="currentColor"
    />
  </svg>
);
